'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLatestWidgetData = undefined;

var _reselect = require('reselect');

var _getters = require('conversations-async-data/async-data/operators/getters');

var _getWidgetDataAsyncData = require('./getWidgetDataAsyncData');

var getLatestWidgetData = exports.getLatestWidgetData = (0, _reselect.createSelector)(_getWidgetDataAsyncData.getWidgetDataAsyncData, function (widgetDataAsyncData) {
  return (0, _getters.getData)(widgetDataAsyncData);
});